export const PAY_INVOICE_ERROR = 'PAY_INVOICE_ERROR';
export const GET_PAYMENT_BY_ID = 'GET_PAYMENT_BY_ID';
export const PAYMENT_LOADED = 'PAYMENT_LOADED';
export const PAYMENT_LOADING = 'PAYMENT_LOADING';
export const PAY_INVOICE = 'PAY_INVOICE';


